var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"Logo",attrs:{"to":'/'}},[_c('img',{attrs:{"src":require("./../assets/logo.png"),"alt":"logo.png"}}),_c('strong',[_vm._v("Weui-Design-Vue")])])}
var staticRenderFns = []

export { render, staticRenderFns }